import {type FC, memo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as CRUProgramMaterialPublicationDayProps} from './MaterialPublicationDay';

import CRUProgramMaterialPublicationDay from './MaterialPublicationDay';

type Props = Partial<ModalProps> & CRUProgramMaterialPublicationDayProps;

const CRUProgramMaterialPublicationDayModal: FC<Props> = ({
  children,
  material,
  onSuccess,
  program,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal
      {...modalProps}
      title={t('shared:CRUProgramMaterialPublicationDay.title')}
    >
      <CRUProgramMaterialPublicationDay
        material={material}
        onSuccess={onSuccess}
        program={program}
      />
      {children}
    </Modal>
  );
};

export default memo(CRUProgramMaterialPublicationDayModal);
